import { render, staticRenderFns } from "./ambassadorList.vue?vue&type=template&id=1a07d27c&scoped=true"
import script from "./ambassadorList.vue?vue&type=script&lang=js"
export * from "./ambassadorList.vue?vue&type=script&lang=js"
import style0 from "./ambassadorList.vue?vue&type=style&index=0&id=1a07d27c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a07d27c",
  null
  
)

export default component.exports